import { Col, Row } from 'reactstrap';
import Radio from 'common/components/form/inputs/Radio';

const TopPart = ({ type, selectField }) => {
  const onChange = type => {
    selectField('default')(type);
  };

  return (
    <Row className="no-gutters pe-6">
      <Col xs={12} className="d-flex align-items-center fs-12">
        <div className="text-primary fw-bold mb-2">DEFAULT BEHAVIOUR:</div>
      </Col>
      <Col xs={12} className="d-flex align-items-center fs-12 border-bottom">
        <Radio
          onChange={() => onChange('show')}
          checked={type === 'show'}
          className="fs-14"
          label="Show to all"
        />
        <Radio
          onChange={() => onChange('hide')}
          checked={type === 'hide'}
          className="ms-5 fs-14"
          label="Hide from all"
        />
      </Col>
      <Col xs={12} className="pt-3">
        <span className="fs-12 fw-bold text-violet">
          {type === 'show' ? 'BLACKLIST' : 'WHITELIST'}
        </span>
      </Col>
    </Row>
  );
};

export default TopPart;
